/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  EditScheduledWithdraw: (params: vp.EditScheduledWithdrawRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostEditScheduledWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldEditScheduledWithdraw, setShouldEditScheduledWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.EditScheduledWithdrawRequest>({
    ScheduledTransactionID: '',
    UpcomingPayment: '',
    Amount: '',
    NewDate: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldEditScheduledWithdraw) return () => {};

    const PostEditScheduledWithdraw = async () => {
      setDataFetchingInfo(true, 'Loading', 'fullScreen');
      const res = await api.postEditScheduledWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldEditScheduledWithdraw) void PostEditScheduledWithdraw();
    setShouldEditScheduledWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldEditScheduledWithdraw]);

  return [
    response,
    (_params: vp.EditScheduledWithdrawRequest) => {
      setParams(_params);
      setShouldEditScheduledWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldEditScheduledWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostEditScheduledWithdraw);
